var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrailerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "232px",
    height: "93px",
    viewBox: "0 0 232 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "xxxhdpi/graph/trailer_grey") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-Entrance---None-state",
    transform: "translate(-1223.000000, -366.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/trailer_grey",
    transform: "translate(1223.000000, 366.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,69.2717495 C174.758558,62.5994047 167.916403,58 160,58 C151.107314,58 143.570176,63.8037897 140.969784,71.8301714 L67.4503811,71.8301714 C65.9839696,64.1689057 61.7713753,60.8764913 52.1529842,60.0852461 C47.8707688,60.0852461 30.4864408,60.0852461 1.16226473e-16,60.0852461 L0,0 L232,0 L232,71.8301714 C224.359034,71.8301714 218.826125,71.8301714 215.401274,71.8301714 L215.030216,71.8301714 C212.429824,63.8037897 204.892686,58 196,58 C188.083597,58 181.241442,62.5994047 178,69.2717495 Z",
    id: "Combined-Shape",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#DDDDDD",
    strokeWidth: 7,
    cx: 160,
    cy: 78,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#DDDDDD",
    strokeWidth: 7,
    cx: 196,
    cy: 78,
    r: 11.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerIcon);
export default __webpack_public_path__ + "static/media/trailer_icon.e3d9d0c151210eccf551551d7cd41b9a.svg";
export { ForwardRef as ReactComponent };